"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fuseIndex = void 0;
var fuse_js_1 = __importDefault(require("fuse.js"));
function fuseIndex(suggestions) {
    var docs = suggestions.map(function (suggestion) {
        return {
            text: suggestion.segments
                .map(function (segment) { return (typeof segment === 'string' ? segment : segment.join(' ')); })
                .join(''),
        };
    });
    var fuse = new fuse_js_1.default(docs, {
        keys: ['text'],
        minMatchCharLength: 2,
        threshold: 0.1,
        ignoreLocation: true,
        fieldNormWeight: 1,
        shouldSort: true,
    });
    return function (text) {
        if (!text)
            return [];
        var results = fuse.search(text, { limit: 10 });
        return results.map(function (result) { return suggestions[result.refIndex]; });
    };
}
exports.fuseIndex = fuseIndex;
//# sourceMappingURL=fuseIndex.js.map